// Privacy.tsx
import React from 'react';

const Privacy: React.FC = () => {
  return (
    <section className="privacy">
      <div className="container text-center my-5 py-5">
      <h1>Privacy Policy</h1>
      <div className="text-start">
        <p>Last updated: May 04, 2026</p>
        <p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information
          when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
        <p>We do not collect any Personal Data from Our users. Kubo TapTap is designed to be a safe and private environment for children.</p>
        
        <h2>Interpretation and Definitions</h2>
        <h3>Definitions</h3>
        <p>For the purposes of this Privacy Policy:</p>
        <ul>
          <li>
            <p><strong>Application</strong> refers to Kubo TapTap, the software program provided by the Company.</p>
          </li>
          <li>
            <p><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Kubo TapTap.</p>
          </li>
          <li>
            <p><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</p>
          </li>
          <li>
            <p><strong>Service</strong> refers to the Application.</p>
          </li>
          <li>
            <p><strong>You</strong> means the individual accessing or using the Service.</p>
          </li>
        </ul>

        <h2>Collecting and Using Your Personal Data</h2>
        <h3>No Personal Data Collection</h3>
        <p>Kubo TapTap does not collect, store, or share any personally identifiable information from its users. We do not require you to create an account, provide an email address, or share any personal information to use the Application.</p>

        <h3>Usage Data</h3>
        <p>We do not collect Usage Data. The Application runs entirely locally on your device and does not transmit information about your usage to our servers.</p>

        <h2>Children's Privacy</h2>
        <p>Our Service is designed for children. We do not knowingly collect personally identifiable information from children under the age of 13. We are committed to complying with the Children's Online Privacy Protection Act (COPPA).</p>
        <p>Since we do not collect any personal data, there is no risk of children's information being shared or used improperly through our Application.</p>

        <h2>Changes to this Privacy Policy</h2>
        <p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>
        <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

        <h2>Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, You can contact us:</p>
        <ul>
          <li>
            <p>By email: huytbt@gmail.com</p>
          </li>
        </ul>
      </div>
      </div>
    </section>
  );
};

export default Privacy;
